export const sum = <T>(arr: readonly T[], field: (x: T) => number) => {
	return arr.reduce((acc, cur) => acc + field(cur), 0)
}

export const paginate = <T>(array: T[], pageSize: number) => {
	return Array.from({ length: Math.ceil(array.length / pageSize) }).map((_, index) => {
		return array.slice(index * pageSize, (index + 1) * pageSize)
	})
}

export function filterDuplicates<T>(arr: T[], identity: (x: T) => string)
{
	const seen = new Set<string>()
	return arr.filter(x =>
	{
		const id = identity(x)
		if (seen.has(id))
			return false

		seen.add(id)
		return true
	})
}

export function removeIndexes<T>(arr: T[], indexes: number[])
{
	let offset = 0
	for (const i of indexes)
	{
		arr.splice(i - offset, 1)
		offset++
	}
}
